/*
 * Gợi ý quy đổi khi khai hồ sơ đơn vị — anh Toàn chốt 19/09/2026 (UOM-R01): 1 Gross = 144 cái, 1 K = 1.000 cái. Chỉ là GỢI Ý điền
 * sẵn vào ô trống: người khai kiểm tra lại cho từng mã và admin duyệt mới có hiệu lực. Set thay đổi theo từng mã nên không gợi ý.
 * Không nhận "gr" (dễ lẫn với gram) hay "kg".
 */
const PIECES = /^(pc|pcs|piece|pieces|cái|cai)$/i;
const GROSS = /^(gross|grs)$/i;
const THOUSAND = /^(k|kpcs)$/i;
const PER_UNIT: [RegExp, string][] = [[GROSS, "144"], [THOUSAND, "1000"]];

export function suggestConversion(unit: string, baseUnit: string): { alternateQuantity: string; baseQuantity: string } | null {
  const u = unit.trim(), base = baseUnit.trim();
  if (PIECES.test(base)) {
    const hit = PER_UNIT.find(([rx]) => rx.test(u));
    return hit ? { alternateQuantity: "1", baseQuantity: hit[1] } : null;
  }
  if (PIECES.test(u)) {
    const hit = PER_UNIT.find(([rx]) => rx.test(base));
    return hit ? { alternateQuantity: hit[1], baseQuantity: "1" } : null;
  }
  return null;
}
